<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.jadwal }}</strong>
          </p>
        </template>
        <CRow>
          <CCol col="12" sm="12">
            <CRow>
              <CCol md="3" sm="12">
                <b-form-group :label="$store.state.form.karyawan" label-for="namaKaryawan">
                  <b-form-input id="namaKaryawan" v-model="filter.namaKaryawan" type="text" placeholder="nama karyawan"></b-form-input>
                </b-form-group>
              </CCol>
              <CCol md="3" sm="12">
                <b-form-group :label="$store.state.form.posisi" label-for="namaPosisi">
                  <b-form-input id="namaPosisi" v-model="filter.namaPosisi" type="text" placeholder="posisi"></b-form-input>
                </b-form-group>
              </CCol>
              <CCol md="3" sm="12">
                <b-form-group :label="$store.state.form.cabang" label-for="cabang">
                  <multiselect
                    id="cabang"
                    class="m-0 p-0"
                    style="white-space: nowrap"
                    v-model="filter.cabang"
                    :options="listCabang"
                    :multiple="false"
                    :searchable="true"
                    :close-on-select="true"
                    label="namaCabang"
                    track-by="cabangId"
                    placeholder="cabang"
                    size="sm"
                  ></multiselect>
                </b-form-group>
              </CCol>
              <CCol md="3" sm="12">
                <b-form-group label="Week" label-for="week">
                  <b-form-input id="filter-input" locale="id-ID" v-model="filter.week" type="week"></b-form-input>
                </b-form-group>
              </CCol>
              <CCol col="12">
                <CRow>
                  <CCol col="6"></CCol>
                  <CCol col="6">
                    <CRow>
                      <CCol col="8"></CCol>
                      <CCol md="4" sm="12">
                        <b-button class="d-block w-100" variant="danger" @click="reset()">Reset</b-button>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol cols="12" md="12" lg="12"><hr /></CCol>
          <CCol cols="12" md="12" lg="12" class="mb-3">
            <b-button class="mr-3" variant="success" @click="$bvModal.show('modal-input-jadwal-lengkap')">{{ $store.state.table.tambahJadwal }}</b-button>
            <!-- <b-button
              class=""
              variant="success"
              @click="$bvModal.show('modal-input-jadwal')"
              >Tambah Jadwal</b-button
            > -->
          </CCol>
          <CCol cols="12" md="12" lg="12">
            <b-table style="white-space: nowrap" :items="items" :fields="display_fields" stacked="md" responsive show-empty small striped hover foot-clone :busy="tableBusy">
              <template #table-busy>
                <div class="text-center p-3">
                  <b-spinner small type="grow"></b-spinner>
                  Loading...
                </div>
              </template>

              <template #cell(namaKaryawan)="item">
                <!-- <div class="w-100 h-100 p-auto m-auto"> -->
                <div class="d-flex justify-content-between h-100 w-100" style="" @click="data = item.item">
                  <p class="m-0 p-0 pr-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%">
                    {{ item.item.namaKaryawan }}
                  </p>
                  <p v-if="!isMobile" class="text-success">{{ item.item.jumlahJam }}h</p>
                </div>
                <!-- </div> -->
              </template>
              <template #cell(tanggal0)="item">
                <div
                  v-if="item.item"
                  class="w-100 h-100 p-auto m-auto"
                  @click="(data = item.item), (dataShift = item.item.tanggal0 || null), (tanggalPilih = $moment(tanggalHari[0]).format('DD-MM-YYYY')), $bvModal.show('modal-pilih-jadwal')"
                >
                  <div v-if="item.item.tanggal0" class="h-auto px-2 py-2 rounded" :style="`background-color: ${item.item.tanggal0.warna}; `">
                    <h6 class="p-0 m-0 mb-1" :class="{ 'my-2 py-1': !item.item.tanggal0.namaJamKerja }">
                      {{ item.item.tanggal0.kategoriShift }}
                    </h6>
                    <p class="p-0 m-0">{{ item.item.tanggal0.namaJamKerja }}</p>
                  </div>
                  <div v-else class="h-auto px-2 py-2 rounded bg-secondary">
                    <h6 class="p-0 m-0 mb-1 py-2">Kosong</h6>
                  </div>
                </div>
              </template>
              <template #cell(tanggal1)="item">
                <div
                  v-if="item.item"
                  class="w-100 h-100 p-auto m-auto"
                  @click="(data = item.item), (dataShift = item.item.tanggal1 || null), (tanggalPilih = $moment(tanggalHari[1]).format('DD-MM-YYYY')), $bvModal.show('modal-pilih-jadwal')"
                >
                  <div v-if="item.item.tanggal1" class="h-auto px-2 py-2 rounded" :style="`background-color: ${item.item.tanggal1.warna}; `">
                    <h6 class="p-0 m-0 mb-1" :class="{ 'my-2 py-1': !item.item.tanggal1.namaJamKerja }">
                      {{ item.item.tanggal1.kategoriShift }}
                    </h6>
                    <p class="p-0 m-0">{{ item.item.tanggal1.namaJamKerja }}</p>
                    <!-- {{ $moment(item.item.tanggal1.createdAt ).format('DD-MM-YYYY HH:mm')}} -->
                  </div>
                  <div v-else class="h-auto px-2 py-2 rounded bg-secondary">
                    <h6 class="p-0 m-0 mb-1 py-2">Kosong</h6>
                  </div>
                </div>
              </template>
              <template #cell(tanggal2)="item">
                <div
                  v-if="item.item"
                  class="w-100 h-100 p-auto m-auto"
                  @click="(data = item.item), (dataShift = item.item.tanggal2 || null), (tanggalPilih = $moment(tanggalHari[2]).format('DD-MM-YYYY')), $bvModal.show('modal-pilih-jadwal')"
                >
                  <div v-if="item.item.tanggal2" class="h-auto px-2 py-2 rounded" :style="`background-color: ${item.item.tanggal2.warna}; `">
                    <h6 class="p-0 m-0 mb-1" :class="{ 'my-2 py-1': !item.item.tanggal2.namaJamKerja }">
                      {{ item.item.tanggal2.kategoriShift }}
                    </h6>
                    <p class="p-0 m-0">{{ item.item.tanggal2.namaJamKerja }}</p>
                  </div>
                  <div v-else class="h-auto px-2 py-2 rounded bg-secondary">
                    <h6 class="p-0 m-0 mb-1 py-2">Kosong</h6>
                  </div>
                </div>
              </template>
              <template #cell(tanggal3)="item">
                <div
                  v-if="item.item"
                  class="w-100 h-100 p-auto m-auto"
                  @click="(data = item.item), (dataShift = item.item.tanggal3 || null), (tanggalPilih = $moment(tanggalHari[3]).format('DD-MM-YYYY')), $bvModal.show('modal-pilih-jadwal')"
                >
                  <div v-if="item.item.tanggal3" class="h-auto px-2 py-2 rounded" :style="`background-color: ${item.item.tanggal3.warna}; `">
                    <h6 class="p-0 m-0 mb-1" :class="{ 'my-2 py-1': !item.item.tanggal3.namaJamKerja }">
                      {{ item.item.tanggal3.kategoriShift }}
                    </h6>
                    <p class="p-0 m-0">{{ item.item.tanggal3.namaJamKerja }}</p>
                  </div>
                  <div v-else class="h-auto px-2 py-2 rounded bg-secondary">
                    <h6 class="p-0 m-0 mb-1 py-2">Kosong</h6>
                  </div>
                </div>
              </template>
              <template #cell(tanggal4)="item">
                <div
                  v-if="item.item"
                  class="w-100 h-100 p-auto m-auto"
                  @click="(data = item.item), (dataShift = item.item.tanggal4 || null), (tanggalPilih = $moment(tanggalHari[4]).format('DD-MM-YYYY')), $bvModal.show('modal-pilih-jadwal')"
                >
                  <div v-if="item.item.tanggal4" class="h-auto px-2 py-2 rounded" :style="`background-color: ${item.item.tanggal4.warna}; `">
                    <h6 class="p-0 m-0 mb-1" :class="{ 'my-2 py-1': !item.item.tanggal4.namaJamKerja }">
                      {{ item.item.tanggal4.kategoriShift }}
                    </h6>
                    <p class="p-0 m-0">{{ item.item.tanggal4.namaJamKerja }}</p>
                  </div>
                  <div v-else class="h-auto px-2 py-2 rounded bg-secondary">
                    <h6 class="p-0 m-0 mb-1 py-2">Kosong</h6>
                  </div>
                </div>
              </template>
              <template #cell(tanggal5)="item">
                <div
                  v-if="item.item"
                  class="w-100 h-100 p-auto m-auto"
                  @click="(data = item.item), (dataShift = item.item.tanggal5 || null), (tanggalPilih = $moment(tanggalHari[5]).format('DD-MM-YYYY')), $bvModal.show('modal-pilih-jadwal')"
                >
                  <div v-if="item.item.tanggal5" class="h-auto px-2 py-2 rounded" :style="`background-color: ${item.item.tanggal5.warna}; `">
                    <h6 class="p-0 m-0 mb-1" :class="{ 'my-2 py-1': !item.item.tanggal5.namaJamKerja }">
                      {{ item.item.tanggal5.kategoriShift }}
                    </h6>
                    <p class="p-0 m-0">{{ item.item.tanggal5.namaJamKerja }}</p>
                  </div>
                  <div v-else class="h-auto px-2 py-2 rounded bg-secondary">
                    <h6 class="p-0 m-0 mb-1 py-2">Kosong</h6>
                  </div>
                </div>
              </template>
              <template #cell(tanggal6)="item">
                <div
                  v-if="item.item"
                  class="w-100 h-100 p-auto m-auto"
                  @click="(data = item.item), (dataShift = item.item.tanggal6 || null), (tanggalPilih = $moment(tanggalHari[6]).format('DD-MM-YYYY')), $bvModal.show('modal-pilih-jadwal')"
                >
                  <div v-if="item.item.tanggal6" class="h-auto px-2 py-2 rounded" :style="`background-color: ${item.item.tanggal6.warna}; `">
                    <h6 class="p-0 m-0 mb-1" :class="{ 'my-2 py-1': !item.item.tanggal6.namaJamKerja }">
                      {{ item.item.tanggal6.kategoriShift }}
                    </h6>
                    <p class="p-0 m-0">{{ item.item.tanggal6.namaJamKerja }}</p>
                  </div>
                  <div v-else class="h-auto px-2 py-2 rounded bg-secondary">
                    <h6 class="p-0 m-0 mb-1 py-2">Kosong</h6>
                  </div>
                </div>
              </template>
              <template #foot(no)><p></p></template>
              <template #foot(namaKaryawan)><p></p></template>
              <template #foot()="data">
                <div class="d-flex justify-content-between mx-1" style="font-size: 0.8em">
                  <div class="d-flex my-auto mr-2">
                    <div class="d-flex my-auto mr-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
                        <path
                          d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z"
                        />
                      </svg>
                    </div>
                    <div class="">
                      {{ getFooter(data.field.key, "jadwal") }}
                    </div>
                  </div>
                  <div class="d-flex flex-column text-right">
                    <div class="">{{ getFooter(data.field.key, "jam") }}h</div>
                    <div class="">
                      {{ getFooter(data.field.key, "nominalUpah") }}
                    </div>
                  </div>
                </div>
              </template>
            </b-table>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-pilih-jadwal :listCabang="listCabang" :data="data" :dataShift="dataShift" :tanggal="tanggalPilih" @changeVar="changeVar" @triggerAlert="triggerAlert($event)" />
    <modal-input-jadwal :listCabang="listCabang" :data="data" :tanggal="tanggalPilih" @changeVar="changeVar" @triggerAlert="triggerAlert($event)" />
    <modal-input-jadwal-lengkap :listCabang="listCabang" :filter="filter" @triggerAlert="triggerAlert($event)" />
  </CRow>
</template>

<script>
import ModalPilihJadwal from "./modalPilihJadwal.vue";
import ModalInputJadwal from "./modalInputJadwal.vue";
import ModalInputJadwalLengkap from "./modalInputJadwalLengkap.vue";
import debounce from "lodash/debounce";

export default {
  components: {
    ModalPilihJadwal,
    ModalInputJadwal,
    ModalInputJadwalLengkap,
  },
  name: "jadwal",
  data() {
    return {
      filter: {
        week: null,
        namaKaryawan: null,
        kategoriShift: null,
        namaPosisi: null,
        cabang: null,
      },
      initializing: false,
      tanggalPertama: null,
      tanggalHari: [],
      tanggalPilih: null,
      dataShift: {},
      items: [],
      data: {},
      listCabang: [],
      edit: false,
      fields: [
        {
          key: "namaKaryawan",
          label: this.$store.state.form.karyawan,
          sortDirection: "desc",
          class: "text-center ",
          filter: false,
          sorter: false,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      tableBusy: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    cabang_aktif() {
      return this.$store.state.cabang_aktif;
    },
    isMobile() {
      return window.innerWidth <= 600;
    },
    lang() {
      return this.$store.state.lang;
    },
    display_fields() {
      return this.fields;
    },
  },
  watch: {
    cabang_aktif(newVar, oldVar) {
      if (newVar != oldVar) {
        this.filter.cabang = newVar;
      }
    },
    currentPage(newVar, oldVar) {
      if (newVar != oldVar && newVar) {
        this.getDatas();
      }
    },
    perPage(newVar, oldVar) {
      if (newVar != oldVar && newVar) {
        this.getDatas();
      }
    },
    lang(newVar, oldVar) {
      if (newVar != oldVar && newVar) {
        this.getTanggalHari();
      }
    },
    "filter.week"(newVar, oldVar) {
      if (this.initializing) return;
      if (newVar != oldVar) {
        this.tanggalPertama = this.$moment(newVar, "YYYY-[W]WW");
        this.getTanggalHari();
      }
    },
    filter: {
      deep: true,
      handler() {
        if (this.initializing) return;
        this.debounceGetDatas();
      },
    },
  },
  async mounted() {
    this.initializing = true;
    await this.getCabang();
    await this.reset();
    this.initializing = false;
  },
  methods: {
    debounceGetDatas: debounce(function () {
      this.getDatas();
    }, 500),
    async getTanggalHari() {
      const vm = this;
      var mulaiTanggal = this.tanggalPertama || vm.$moment(vm.$moment().startOf("week").toDate()).add(1, "days");
      //buat tanggal hari dalam minggu ini
      const field = [vm.fields[0]];
      this.fields = [];
      this.tanggalHari = [];
      for (let i = 0; i < 7; i++) {
        let tanggal = vm.$moment(mulaiTanggal).add(i, "days");
        let lang = vm.$store.state.lang || "id";
        this.tanggalHari.push(tanggal);
        field.push({
          key: "tanggal" + i,
          label: tanggal.locale(lang).format("dddd, DD MMMM"),
          sortable: false,
          sortDirection: "desc",
          class: "text-center",
        });
      }
      // console.log('field', field)
      this.fields = field;
      await this.getDatas();
    },
    getFooter(key, nama) {
      const vm = this;
      let jumlah = 0;
      switch (nama) {
        case "jadwal":
          for (let i = 0; i < vm.items.length; i++) {
            if (vm.items[i][key]) {
              jumlah++;
            }
          }
          return jumlah;
        case "jam":
          for (let i = 0; i < vm.items.length; i++) {
            if (vm.items[i][key]) {
              const data = vm.items[i][key];
              jumlah += data.jamMasuk ? Math.round(vm.$moment.duration(vm.$moment(data.jamKeluar, "HH:mm:ss").diff(vm.$moment(data.jamMasuk, "HH:mm:ss"))).asHours()) : 0;
            }
          }
          return jumlah;
        case "nominalUpah":
          for (let i = 0; i < vm.items.length; i++) {
            if (vm.items[i][key]) {
              const data = vm.items[i][key];
              jumlah += data.nominalUpah;
            }
          }
          return vm.$numberFormat(jumlah, "idr");
        default:
          return "";
      }
    },
    async getDatas() {
      let vm = this;
      vm.tableBusy = true;
      vm.items = [];
      const jadwal = await vm.$axios.post("masterShift/listJadwalShiftPerHalaman", {
        jumlah: vm.perPage,
        halaman: vm.currentPage - 1,
        ...vm.filter,
        cabangId: vm.filter.cabang ? vm.filter.cabang.cabangId : null,
        tglAwal: vm.$moment(vm.tanggalHari[0]).format("YYYY-MM-DD"),
        tglAkhir: vm.$moment(vm.$moment(vm.tanggalHari[6]).add(1, "days")).format("YYYY-MM-DD"),
      });

      vm.items = jadwal.data.status == 200 ? jadwal.data.data : [];

      for (let i = 0; i < vm.items.length; i++) {
        const x = vm.items[i];
        x.no = i + 1 + vm.perPage * (vm.currentPage - 1);
        x.cabang = { cabangId: x.cabangId, namaCabang: x.namaCabang };
        x.jumlahJam = 0;
        x.namaKaryawan = x.namaKaryawan.toUpperCase();
        x.namaPosisi = x.namaPosisi.toUpperCase();

        for (let o = 0; o < x.jadwalShift.length; o++) {
          const y = x.jadwalShift[o];
          y.namaJamKerja = y.jamMasuk ? vm.$moment(y.jamMasuk, "HH:mm:ss").format("HH:mm") + " - " + vm.$moment(y.jamKeluar, "HH:mm:ss").format("HH:mm") : "";

          for (let u = 0; u < vm.tanggalHari.length; u++) {
            const z = vm.tanggalHari[u];

            if (vm.$moment(y.tanggalAbsen).format("DD-MM-YYYY") == z.format("DD-MM-YYYY")) {
              if (y.masterShiftId == null && y.kategoriShift?.toLowerCase() === "cuti") {
                x["tanggal" + u] = {
                  ...y,
                  namaCabang: "",
                  namaShift: "Cuti",
                  kategoriShift: "Cuti",
                  namaNominalUpah: "",
                  namaTanggalAbsen: vm.$moment(y.tanggalAbsen).format("DD-MM-YYYY"),
                  warna: "#C8E6C9",
                };
              } else if (y.masterShiftId == null) {
                x["tanggal" + u] = {
                  ...y,
                  namaCabang: "",
                  namaShift: "Day Off",
                  kategoriShift: "Day Off",
                  namaNominalUpah: "",
                  namaTanggalAbsen: vm.$moment(y.tanggalAbsen).format("DD-MM-YYYY"),
                  warna: "#f0f2f5",
                };
              } else {
                x.jumlahJam += Math.round(vm.$moment.duration(vm.$moment(y.jamKeluar, "HH:mm:ss").diff(vm.$moment(y.jamMasuk, "HH:mm:ss"))).asHours());
                x["tanggal" + u] = {
                  ...y,
                  namaCabang: y.namaCabang.toUpperCase(),
                  namaShift: y.namaShift.toUpperCase(),
                  kategoriShift: y.kategoriShift.toUpperCase(),
                  namaNominalUpah: vm.$numberFormat(y.nominalUpah, "idr"),
                  namaTanggalAbsen: vm.$moment(y.tanggalAbsen).format("DD-MM-YYYY"),
                };
              }
            }
          }
        }
      }

      vm.totalRows = Number.parseInt(jadwal.data.count);
      vm.tableBusy = false;
    },
    async getCabang() {
      let vm = this;
      const cabang = await vm.$axios.get("cabang/list");
      // console.log('cabang', cabang)
      vm.listCabang = cabang.data.status == 200 ? cabang.data.data : [];
    },
    reset() {
      this.filter = {
        week: this.$moment().format("YYYY-[W]WW"),
        namaKaryawan: null,
        kategoriShift: null,
        namaPosisi: null,
        cabang: this.cabang_aktif,
      };
      this.getTanggalHari();
    },
    triggerAlert(event) {
      let vm = this;
      console.log(event);
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
